"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _algoliaService = require("../../services/algoliaService");

var _localStorageCache = _interopRequireDefault(require("../../utils/localStorageCache"));

var _config = require("../../libs/config");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

module.exports = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
  var content, CONVERSION_TIME;
  return _regenerator.default.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          content = _localStorageCache.default.getItemAndRemove(_config.SEARCH_CONVERSION);

          if (content) {
            _context.next = 3;
            break;
          }

          return _context.abrupt("return");

        case 3:
          CONVERSION_TIME = 30000; // eslint-disable-next-line no-console

          console.log('[Algolia Analytics] Conversion event - userToken from localStorage:', content.userToken);
          (0, _algoliaService.getSearchToken)(function (data) {
            (0, _algoliaService.insights)('init', {
              appId: data.client_id,
              apiKey: data.token
            });
            setTimeout(function recordConversion() {
              // eslint-disable-next-line no-console
              console.log('[Algolia Analytics] Sending conversion - userToken:', content.userToken);
              (0, _algoliaService.insights)('convertedObjectIDsAfterSearch', _objectSpread(_objectSpread({}, content), {}, {
                eventName: "".concat(content.sourceType ? "[".concat(content.sourceType, "] ") : '', "Search item read after ").concat(CONVERSION_TIME / 1000, "s")
              }, content.userToken && {
                userToken: content.userToken
              }));
            }, CONVERSION_TIME);
          });

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}));